import { render, staticRenderFns } from "./TaskDel.vue?vue&type=template&id=bf5755d2&scoped=true&"
import script from "./TaskDel.vue?vue&type=script&lang=js&"
export * from "./TaskDel.vue?vue&type=script&lang=js&"
import style0 from "./TaskDel.vue?vue&type=style&index=0&id=bf5755d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5755d2",
  null
  
)

export default component.exports